const MetodoPagamentoEnum = {
  PIX: 'PIX',
  FATURAMENTO: 'FATURAMENTO',
  TRANSFERENCIA: 'TRANSFERÊNCIA'
}

export default MetodoPagamentoEnum;
